import { GOAL_PARENT_QUERY_LEVEL } from '@/lib/constants';
import { parentAlignmentType } from 'shared/constants.json';

export const parentAlignmentToLevels = (parentAlignment) => {
  switch (parentAlignment) {
    case parentAlignmentType.hidden:
      return 1;
    case parentAlignmentType.direct:
      return 2;
    case parentAlignmentType.full:
      return GOAL_PARENT_QUERY_LEVEL;
    default:
      return 0;
  }
};
